const Form079EN = {
    stepName: {
        importantNotes: "重要事項",
        organisationInfo: "機構信息",
        venuesAddress: "上課中心地址",
        declaration: "聲明",
        confirmation: "確認",
    },
    title: "申辦{{financialYear}}財政年度新來港兒童適應課程",
    formBoxTitle: {
        notes: "備註",
        note: "提示",
        forward:
            "本人現遞交{{financialYear}}財政年度新來港兒童適應課程的開辦申請及所須的機構資料，並聲明就本人所知，申請表內所填報的資料真確無誤。",
        organisation: "機構資料",
        organInfo: "機構資料",
        organOption: {
            one: "I. 主辦機構",
            two: "II. 擁有人/主辦者",
            three: "III. 聯絡人",
            four: "IV. 申請豁免學校註冊地址",
            partA: "甲部：以<u><b>“非為學校用途而設計和建造的房產”</b></u>為上課中心",
            partB: "乙部：以<u><b>學校校舍</b></u>為上課中心",
            five: "V. 擁有人/主辦者聲明",
        },
        pic: "個人資料收集聲明",
    },

    organisation: {
        ordinanceAttachment:
            "附件：稅務局根據稅務條例第八十八條發出以證明機構為認可慈善團體的信件",
        title: {
            t1: "機構負責人",
            t2: "注意：請列出機構在過去兩年為新來港人士舉辦的活動，並連同相關證明文件副本一併交回",
            t3: "舉辦課程/活動經驗",
        },
        nameE: "機構英文名稱",
        nameC: "機構中文名稱",
        addressE: "機構英文地址",
        addressC: "機構中文地址",
        tel: "電話號碼",
        fax: "傳真號碼",
        chairDirect: "主席/會長",
        accTreasurer: "會計師/司庫",
        cdOption: {
            chairman: "主席",
            director: "會長",
        },
        atOption: {
            accountant: "會計師",
            treasurer: "司庫",
        },
        englishName: "英文姓名",
        chineseName: "中文姓名",
        englishInName: "英文姓名",
        chineseInName: "中文姓名",
        telNo: "電話",
        adminNameE: "課程負責人及聯絡人英文姓名",
        adminNameC: "課程負責人及聯絡人中文姓名",
        object: "機構服務宗旨",
        nature: "活動性質(例如：個人發展、家庭生活教育、社區適應等)",
        target: "服務對象(例如： 新來港兒童、新來港人士等)",
        dateFrom: "日期從",
        dateTo: "至",
        duration: "期間",
        // year: "year",
        months: "個月",
        natureAttachment: "附件：證明文件",
        nonProfit: "非牟利機構",
        yes: "是",
        no: "否",
        profitAttach: "附件：文件（如稅務局信件）證明主辦機構為非牟利慈善團體",
        // guide: "行政指引",
        guide: "{{financialYear}}財政年度新來港兒童適應課程行政指引",
        email: "電郵地址",
    },
    note: "豁免學校註冊申請書 ({{revisionDate}}修訂版)",
    organOne: {
        nameE: "機構英文名稱",
        nameC: "機構中文名稱",
        addressE: "機構英文地址",
        addressC: "機構中文地址",
        tel: "電話號碼",
        fax: "傳真號碼",
    },
    organTwo: {
        appTitle: "稱謂",
        appTitleOption: {
            mr: "先生",
            ms: "女士",
        },
        nameE: "英文姓名",
        nameC: "中文姓名",
        addressEn: "英文地址",
        addressCh: "中文地址",
        idNo: "身份證號碼",
        telephoneNo: "電話號碼",
        faxNo: "傳真號碼",
        facsimile: "傳真號碼",
    },
    organThree: {
        name: "姓名",
        post: "職銜",
        corrAddress: "聯絡地址",
        telNoT: "電話號碼",
    },
    organFour: {
        venuesAddress: "請選擇相應的地址",
        venuesOption: {
            builtVenues:
                "甲部：以<u><b>“非為學校用途而設計和建造的房產”</b></u>為上課中心",
            schoolVenues: "乙部：以<u><b>學校校舍</b></u>為上課中心",
        },
    },
    venues: {
        topic: {
            t1: "如以<u>非為學校用途而設計和建造的房產(即商業或商住樓宇等)</u>為上課中心，請填寫甲部。機構負責人應確保所有上課地點俱符合下列各項規定 –",
            t2: "• 上課地點不得位於高度超出地面24米的位置",
            t3: "• 上課地點不能設於單梯樓宇的上層",
            t4: "• 上課地點不能位於工廠、貨倉、戲院或可能危害學生的生命或安全的任何行業在進行的樓宇內",
            t5: "• 上課地點不得有任何違例建築工程",
            t6: "• 上課地點如有容納超過30人的房間或樓層，應最少有兩個出口",
            t7: "• 上課地點不得為未經註冊的補習學校",
            t8: "[借出校舍的校長須填寫同意書一份(附件 Ia )]",
            t9: "如在學校校舍開辦課程，請填寫乙部。",
            t10: "如空位不足，請另紙填寫。",
            t11: "《教育條例》第9條第（5）款規定 –",
            t12: "常任秘書長可藉書面命令，按其認為適當的條件(如有的話)，豁免─ (由2003 年第3 號第11 條修訂)",
            t13: "所提供的教育只由一系列講座，或一學科或題目的授課課程所組成的學校；",
            t14: "每週提供的學術授課少於10小時的學校；及",
            t15: "(a)段或(b)段所提述的任何學校的利害關係人，受本條例所有或任何條文管限。",
            t16: "[請附上有效的證明文件，以證明房產在豁免學校註冊期內符合消防規定，例如F.S. 251 – 消防裝置及設備證書。]",
        },
        certificate: "附件: 消防裝置及設備證書",
        centreName: "中心名稱",
        address: "地址",
        downloadAppendix: "下載附錄 Ia 表格",
        schoolName: "學校名稱",
        appendix: "附件: 附錄Ia",
        consentForm: "同意書",
        periodDate: "申請豁免日期",
        from: "由",
        to: "至",
    },
    label: {
        noteList: {
            note1: "請連同稅務局根據稅務條例第八十八條發出以證明機構為認可慈善團體的信件副本一併交回。",
            note2: "此表格所收集的個人資料，將只用於辦理有關申辦{{financialYear}}財政年度新來港兒童適應課程的事宜。任何與此表格所收集的個人資料有關的查詢，包括要求查閱和改正資料，應提交：",
        },
        noteList1: {
            note3: "香港灣仔皇后大道東213號",
            note4: "胡忠大廈14樓1424室",
            note5: "新來港兒童支援分組",
            note6: "助理教育主任(學位安排及支援)",
            note7: "電話：2892 6189",
        },
        noteList2: {
            note8: "如在非為學校用途而設計的建築物內開辦課程，請填寫甲部。",
            note9: "如在學校校舍開辦課程，請填寫乙部。",
            note10: "如空位不足，請另紙填寫。",
            note11: "《教育條例》第9條第（5）款規定–",
        },
        listNum: {
            note8: "1.",
            note9: "2.",
            note10: "3.",
            note11: "4.",
        },
        noteList3: {
            note12: "常任秘書長可藉書面命令，按其認為適當的條件（如有的話），豁免 – 由2003年第3號第11條修訂）–",
            note14: "所提供的教育只由一系列講座，或一學科或題目的授課課程所組成的學校；",
            note15: "每週提供的學術授課少於 10 小時的學校；及",
            note16: "(a) 段或 (b) 段所提述的任何學校的利害關係人 ，",
            note17: '<p style="margin-left:20px;">受本條例所有或任何條文管限。</p>',
        },
        noteList3Num: {
            note14: "(a)",
            note15: "(b)",
            note16: "(c)",
        },
        noteList4: {
            // note17: "本人有 / 沒有*被裁定已犯有刑事罪行；",
            note17: "本人",
            note19: "被裁定已犯有刑事罪行；",
            note18: "就本人所知所信，本申請書一切內容均屬真實及詳盡。",
        },
        noteList4Num: {
            note17: "(i) ",
            note18: "(ii) ",
        },
    },

    offenceOption: {
        have: "有",
        haveNot: "沒有",
    },

    name: "姓名",
    organName: "機構",
    applicantName: "申請人姓名",
    position: "職位",
    chopAttachment: "附件: 機構印鑑",
    date: "日期",
    proContent: "課程內容建議",
    financialYear: "財政年度",

    errorMsg: {
        telMax: "電話號碼必須為最多12位數",
    },
    picNote: {
        note1: {
            title: `你在本表格提供的個人資料，會供教育局用於以下一項或多項用途：`,
            subtitle: "收集個人資料的目的",
            content1: "處理、核實及查證就新來港兒童適應課程的申請；",
            content2:
                "就上文(a)項所述申請的處理、核實及查證，將個人資料與政府相關政策局／部門資料庫進行核對； ",
            content3:
                "將個人資料與教育局資料庫進行核對，以核實／更新教育局的記錄；",
            content4:
                "培訓及發展，包括發出計劃／活動邀請、處理發還課程費用申請、 評審提名、獎項和獎學金，以及監察達標進度；",
            content5:
                "處理及審核撥款／補助／津貼申請、發放撥款／補助／津貼，以及審計；",
            content6: "編製統計資料、研究及政府刊物；以及",
            content7:
                "執行規則及規例 [包括《教育條例》(香港法例第279章)及其附屬法例(例如《教育規例》、《補助學校公積金規則》、《津貼學校公積金規則》和《資助則例》)] 。",
        },
        note2: {
            title: `你必須按本表格的要求及於本局處理本表格的過程中提供個人資料。假如你沒有提供該等個人資料，本局可能無法辦理或繼續處理申請。`,
        },
        note3: {
            title: `你提供的個人資料會供教育局人員取閱。除此之外，本局亦可能會向下列各方或在下述情況轉移或披露該等個人資料：`,
            subtitle: "可獲轉移資料者",
            content1: "政府其他政策局及部門，以用於上文第1段所述的用途； ",
            content2: "與本表格相關的學校，以用於上文第1段所述的用途；",
            content3: "你曾就披露個人資料給予訂明同意；以及",
            content4: "根據適用於香港的法例或法庭命令授權或規定披露個人資料。",
        },
        note4: {
            title: `你有權要求查閱及更正教育局所持有關於你的個人資料。如需查閱或更正個人資料，請以書面向助理教育主任(學位安排及支援)32提出(地址：香港灣仔皇后大道東213號胡忠大廈14樓1424室或電郵：aeops32@edb.gov.hk)。`,
            subtitle: "查閱個人資料",
        },
    },
    formExpired: "此表格正在維護中，無法提交申請。",
};

export default Form079EN;
